import { DayColumn, HOURS, SLOT_HEIGHT } from "@/components/calendar/DayView";

function startOfWeek(d) {
  const x = new Date(d);
  const day = (x.getDay() + 6) % 7;
  x.setHours(0, 0, 0, 0);
  x.setDate(x.getDate() - day);
  return x;
}

export default function WeekView({ date, appointments, onApptClick, onSlotClick, movingAppointment }) {
  const start = startOfWeek(date);
  const days = Array.from({ length: 7 }, (_, i) => { const d = new Date(start); d.setDate(d.getDate() + i); return d; });
  return (
    <div className="flex flex-col overflow-x-auto">
      <div className="min-w-[720px]">
      {/* Day headers */}
      <div className="flex sticky top-0 z-10 bg-card">
        <div className="stellar-week-time-corner w-14 shrink-0" />
        <div className="flex flex-1 min-w-0">
          {days.map((d) => {
            const isToday = d.toDateString() === new Date().toDateString();
            const dow = d.getDay();
            const isWeekend = dow === 0 || dow === 6;
            const bg = isToday
              ? "bg-emerald-50 text-emerald-800 font-semibold border-b-2 border-b-emerald-500"
              : (isWeekend ? "bg-amber-50/70 dark:bg-amber-900/10 text-muted-foreground" : "text-muted-foreground");
            return (
              <div key={d.toISOString()} className={`flex-1 text-center text-xs py-2 border-b border-r border-border/60 last:border-r-0 ${bg}`}>
                <div className="uppercase tracking-widest">{d.toLocaleDateString("de-DE", { weekday: "short" })}</div>
                <div className={`mx-auto mt-0.5 flex h-7 w-7 items-center justify-center rounded-full text-base font-display font-semibold ${isToday ? "bg-emerald-600 text-white shadow-sm ring-2 ring-emerald-200" : "text-foreground"}`}>{d.getDate()}</div>
              </div>
            );
          })}
        </div>
      </div>
      {/* Hourly grid — ALL appointments (single- and multi-day) rendered as time blocks inside DayColumn */}
      <div className="flex">
        <div className="stellar-week-time-rail w-14 shrink-0">
          {HOURS.map((h) => (
            <div key={h} className="text-[10px] text-muted-foreground text-right pr-2 border-b border-border/40" style={{ height: SLOT_HEIGHT }}>
              <span className="-translate-y-2 inline-block">{String(h).padStart(2, "0")}:00</span>
            </div>
          ))}
        </div>
        <div className="flex flex-1 min-w-0">
          {days.map((d) => (
            <DayColumn
              key={d.toISOString()}
              date={d}
              appointments={appointments}
              onApptClick={onApptClick}
              onSlotClick={onSlotClick}
              movingAppointment={movingAppointment}
              showHeader={false}
            />
          ))}
        </div>
      </div>
      </div>
    </div>
  );
}
